import React, { FC } from 'react';
import { LeftMatchItem } from '../QuizMatchStore';
import { CorrectBadge } from './CorrectBadge';
import { IncorrectBadge } from './IncorrectBadge';
import { LeftBorder } from './LeftBorder';
import { LeftShape } from './LeftShape';
import { useColor } from './useColor';

export const LeftButton: FC<
  LeftMatchItem & { correct?: boolean; active?: boolean; onClick?: () => void }
> = ({ label, correct, active, onClick }) => {
  const color = useColor(correct);

  return (
    <LeftBorder
      highlightColor={color}
      className={active ? 'LeftBorder active' : 'LeftBorder'}
      onClick={() => {
        if (!correct) {
          onClick!();
        }
      }}
    >
      {correct === true ? (
        <CorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}
      {correct === false ? (
        <IncorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}
      <LeftShape className={'LeftShape'}>{label}</LeftShape>
    </LeftBorder>
  );
};
